import { createQuery } from './core';
// PUBLIC API
export const getPaginatedUsers = createQuery('operations/get-paginated-users', ['User']);
// PUBLIC API
export const getPaginatedArticles = createQuery('operations/get-paginated-articles', ['Article', 'Bookmark']);
// PUBLIC API
export const getRssFeeds = createQuery('operations/get-rss-feeds', ['RssFeed']);
// PUBLIC API
export const getHardcodedRssFeeds = createQuery('operations/get-hardcoded-rss-feeds', ['RssFeed']);
// PUBLIC API
export const getAdminWorkflowSummary = createQuery('operations/get-admin-workflow-summary', ['Article', 'ArticleContent', 'ArticleFlag', 'ContactFormMessage', 'DiscussionReport', 'Logs', 'NewsletterDelivery', 'RssFeed']);
// PUBLIC API
export const getFlaggedArticles = createQuery('operations/get-flagged-articles', ['Article', 'ArticleFlag', 'User']);
// PUBLIC API
export const getArticleWorkflowQueue = createQuery('operations/get-article-workflow-queue', ['Article', 'ArticleContent', 'Bookmark']);
// PUBLIC API
export const getArticleWorkflowDetail = createQuery('operations/get-article-workflow-detail', ['Article', 'ArticleContent', 'Bookmark']);
// PUBLIC API
export const getPublicationWorkflowQueue = createQuery('operations/get-publication-workflow-queue', ['Publication']);
// PUBLIC API
export const getPublicationEditor = createQuery('operations/get-publication-editor', ['Publication']);
// PUBLIC API
export const getInboxMessages = createQuery('operations/get-inbox-messages', ['ContactFormMessage', 'User']);
// PUBLIC API
export const getCustomerPortalUrl = createQuery('operations/get-customer-portal-url', ['User']);
// PUBLIC API
export const getDailyStats = createQuery('operations/get-daily-stats', ['User', 'DailyStats']);
// PUBLIC API
export const getDailyBriefing = createQuery('operations/get-daily-briefing', ['DailyBriefing', 'DailyBriefingStory']);
// PUBLIC API
export const getArticles = createQuery('operations/get-articles', ['Article']);
// PUBLIC API
export const getTrendingArticles = createQuery('operations/get-trending-articles', ['Article']);
// PUBLIC API
export const getTrendStats = createQuery('operations/get-trend-stats', ['Article']);
// PUBLIC API
export const getUserBookmarks = createQuery('operations/get-user-bookmarks', ['Bookmark']);
// PUBLIC API
export const getUserArticleLikes = createQuery('operations/get-user-article-likes', ['ArticleLike']);
// PUBLIC API
export const getUserArticleFlags = createQuery('operations/get-user-article-flags', ['ArticleFlag']);
// PUBLIC API
export const getActivityBookmarks = createQuery('operations/get-activity-bookmarks', ['Bookmark', 'Article']);
// PUBLIC API
export const getActivityLikes = createQuery('operations/get-activity-likes', ['ArticleLike', 'Article']);
// PUBLIC API
export const getActivityDiscussions = createQuery('operations/get-activity-discussions', ['Discussion', 'DiscussionComment', 'DiscussionLike']);
// PUBLIC API
export const getActivityFlags = createQuery('operations/get-activity-flags', ['ArticleFlag', 'Article']);
// PUBLIC API
export const getActivityCounts = createQuery('operations/get-activity-counts', ['Bookmark', 'ArticleLike', 'ArticleFlag', 'Article', 'Discussion', 'DiscussionComment']);
// PUBLIC API
export const getWeeklyRecap = createQuery('operations/get-weekly-recap', ['Bookmark', 'ArticleLike', 'Article', 'Discussion', 'DiscussionComment']);
// PUBLIC API
export const exportUserData = createQuery('operations/export-user-data', ['User', 'Bookmark', 'ArticleLike', 'Discussion', 'DiscussionComment', 'ArticleFlag', 'Article']);
// PUBLIC API
export const getDiscussions = createQuery('operations/get-discussions', ['Discussion']);
// PUBLIC API
export const getDiscussion = createQuery('operations/get-discussion', ['Discussion']);
// PUBLIC API
export const getDiscussionViews = createQuery('operations/get-discussion-views', ['Discussion', 'DiscussionView']);
// PUBLIC API
export const getDiscussionComments = createQuery('operations/get-discussion-comments', ['DiscussionComment']);
// PUBLIC API
export const getPublicProfile = createQuery('operations/get-public-profile', ['User', 'Discussion', 'DiscussionComment']);
// PUBLIC API
export const getUserDiscussions = createQuery('operations/get-user-discussions', ['User', 'Discussion', 'DiscussionLike']);
// PRIVATE API (used in SDK)
export { buildAndRegisterQuery } from './core';
//# sourceMappingURL=index.js.map